import _ from 'lodash'
import { createSelector } from 'reselect'
import { getResidentsList, getZonesList } from './Lists'

export const getZonesWithResidents = createSelector(
  [getResidentsList, getZonesList],
  (residents, zones) => {
    if (!residents || !zones) return null
    if (!zones.length || !residents.length) return []

    const residentsByZone = _(residents)
      .filter(
        (resident) =>
          !!resident.zone && ['active', 'dummy'].includes(resident.status)
      )
      .groupBy('zone')
      .value()

    return _(zones)
      .map((zone) => ({
        ...zone,
        residents: _.get(residentsByZone, zone.id) || []
      }))
      .sortBy('title')
      .value()
  }
)

export const getResidentsWithoutZone = createSelector(
  [getResidentsList, getZonesList],
  (residents, zones) => {
    if (!residents || !zones) return null
    if (!zones.length || !residents.length) return []

    return _.filter(
      residents,
      (resident) =>
        !resident.zone && ['active', 'dummy'].includes(resident.status)
    )
  }
)
